// import { ThemeProvider } from "@material-ui/styles";
import React from "react";
import AppRouter from "./AppRouter";
// import theme from "./GlobalStyles/theme";
import SessionContext from "./context/SessionContext";
import SessionValidator from "./components/core/SessionValidator";
import "crypto-browserify";
import "stream-browserify";

export default function App() {
  const [isSessionExpired, setSessionExpired] = React.useState(false);
  return (
    <React.Fragment>
      <SessionContext.Provider value={{ isSessionExpired, setSessionExpired }}>
        <AppRouter />
        <SessionValidator isSessionExpired={isSessionExpired} />
      </SessionContext.Provider>
    </React.Fragment>
  );
}
